import React from 'react';
import './FormattedJsonViewer.css';

const FormattedSection = (props) => {

    let titleClass = props.titleWidth > 30 ? "formattedjsonviewer-title-wide" : "formattedjsonviewer-title";

    return (  
    <div className={"formattedjsonviewer-gridrowcontainer"}>
        <div className={titleClass}>{props.title}</div>
            {props.data.map((element) => {               
                    let contents = element.Contents;
                    return(                       
                    <div className="formattedsection-item">{contents}</div>
                    )
                })
            }
        </div>
    );
};

export default FormattedSection;